(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('[data-product-section]').forEach(section => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      const form = section.querySelector('form');
      const select = section.querySelector('[data-variant-select]');
      const button = section.querySelector('[data-add-button]');
      const status = section.querySelector('[data-product-status]');
      const price = section.querySelector('[data-product-price]');
      const image = section.querySelector('.product-main-image');
      let submitting = false;
      const showImage = (src, alt) => { if (image && src) { image.removeAttribute('srcset'); image.src = src; image.alt = alt || ''; } };
      const updateVariant = (changeUrl = false) => {
        const option = select.selectedOptions[0];
        if (!option) return;
        price.textContent = option.dataset.price;
        button.disabled = submitting || option.dataset.available !== 'true';
        button.textContent = submitting ? 'Adding…' : option.dataset.available === 'true' ? 'Add to bag' : 'Sold out';
        showImage(option.dataset.image, option.dataset.imageAlt);
        status.textContent = '';
        if (changeUrl) { const url = new URL(location.href); url.searchParams.set('variant', option.value); history.replaceState({}, '', url); }
      };
      select.addEventListener('change', () => updateVariant(true));
      section.querySelectorAll('[data-product-image]').forEach(thumb => thumb.addEventListener('click', () => showImage(thumb.dataset.productImage, thumb.dataset.imageAlt)));
      form.addEventListener('submit', async event => {
        if (!window.fetch || !form.reportValidity()) return;
        event.preventDefault();
        if (submitting || select.selectedOptions[0].dataset.available !== 'true') return;
        const data = new FormData(form);
        submitting = true;
        select.disabled = true;
        updateVariant();
        status.textContent = 'Adding to your bag…';
        try {
          const endpoint = new URL(form.action, location.href);
          endpoint.pathname = endpoint.pathname.replace(/\/$/, '') + '.js';
          const response = await fetch(endpoint, { method: 'POST', body: data, headers: { Accept: 'application/json' }, credentials: 'same-origin' });
          const result = await response.json();
          if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'This item could not be added. Please try again.');
          status.textContent = 'Added to your bag.';
          try {
            const cartUrl = new URL(form.action, location.href);
            cartUrl.pathname = cartUrl.pathname.replace(/\/add\/?$/, '.js');
            const cartResponse = await fetch(cartUrl, { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
            if (cartResponse.ok) { const cart = await cartResponse.json(); document.querySelectorAll('[data-cart-count]').forEach(count => { count.textContent = `(${cart.item_count})`; count.setAttribute('aria-label', `${cart.item_count} items`); }); }
          } catch { /* The add succeeded; a count refresh must not invite a duplicate add. */ }
        } catch (error) { status.textContent = error.message || 'There was a connection problem. Check your bag before trying again.'; }
        finally { submitting = false; select.disabled = false; button.disabled = select.selectedOptions[0].dataset.available !== 'true'; button.textContent = button.disabled ? 'Sold out' : 'Add to bag'; }
      });
      updateVariant();
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.mobile-menu[open], .nav-group[open]').forEach(menu => { menu.open = false; menu.querySelector('summary').focus(); });
  });
  window.addEventListener('pageshow', event => { if (event.persisted) location.reload(); });
})();
